import { CheckCircle, CircleOutlined, RemoveCircle } from "@mui/icons-material";
import { Checkbox, useTheme } from "@mui/material";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import { forwardRef, useMemo } from "react";

const SmallCheckBox = forwardRef(function SmallCheckBox(props, ref) {
  return (
    <Checkbox
      icon={<CircleOutlined />}
      checkedIcon={<CheckCircle />}
      indeterminateIcon={<RemoveCircle />}
      size="small"
      ref={ref}
      {...props}
    />
  );
});

const defaultSlots = {
  baseCheckbox: SmallCheckBox,
};

const defaultSlotProps = {
  baseTooltip: {
    followCursor: true,
  },
};

export default function BaseDataGrid({ slots, slotProps, sortingMode = "server", sx, ...props }) {
  const { palette } = useTheme();

  const gridSx = useMemo(
    () => ({
      border: "none",
      maxWidth: "100vw",
      [`& .${gridClasses.cell}:not(.${gridClasses["cell--editable"]}):focus, & .${gridClasses.cell}:not(.${gridClasses["cell--editable"]}):focus-within`]:
        {
          outline: "none",
        },
      [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
        {
          outline: "none",
        },
      [`& .${gridClasses.cell}.${gridClasses["cell--editable"]}:hover`]: {
        outlineStyle: "solid",
        outlineColor: palette.primary.main,
        outlineWidth: "1px",
        outlineOffset: "-1px",
      },
    }),
    [palette]
  );

  return (
    <DataGrid
      density="compact"
      slots={{ ...defaultSlots, ...slots }}
      slotProps={{ ...defaultSlotProps, ...slotProps }}
      sortingMode={sortingMode}
      sx={{ ...gridSx, ...sx }}
      {...props}
    />
  );
}
